"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
//VARIABLE MODELS
const user_1 = require("./user");
let UsersService = class UsersService {
    constructor(_http, _route, _talk, _router) {
        this._http = _http;
        this._route = _route;
        this._talk = _talk;
        this._router = _router;
        //initializations
        this.userURL = "/user";
    }
    ;
    get() {
        return this.users;
    }
    getWithRoleIndexes() {
        return JSON.parse(JSON.stringify(this.usersWithRoleIndexes));
    }
    getUserById(id) {
        for (let u in this.users) {
            if (this.users[u].id == id) {
                return this.users[u];
            }
        }
        return new user_1.User;
    }
    getUserByEmail(email) {
        for (let u in this.users) {
            if (this.users[u].email == email) {
                return this.users[u];
            }
        }
        return new user_1.User;
    }
    getUserByIdWithRoleIndexes(id) {
        let userArr = JSON.parse(JSON.stringify(this.usersWithRoleIndexes));
        for (let u in userArr) {
            if (userArr[u].id == id) {
                return userArr[u];
            }
        }
        console.log('ERR: USER NOT FOUND');
    }
    pull() {
        return this._http.get(this.userURL)
            .toPromise()
            .then(response => {
            this.users = JSON.parse(response._body);
            this.usersWithRoleIndexes = JSON.parse(JSON.stringify(this.users));
            for (let u in this.usersWithRoleIndexes) {
                for (let r in this.usersWithRoleIndexes[u].roles) {
                    this.usersWithRoleIndexes[u].roles[r] = this.usersWithRoleIndexes[u].roles[r].id;
                }
            }
        })
            .catch(this._talk.handle);
    }
    forgotPassword(email, navigateToLogin, internalReset) {
        return this._http.post('/token/create', { "email": email, "internalReset": !!internalReset })
            .toPromise()
            .then(response => {
            if (navigateToLogin)
                this._router.navigate(['/login']);
            if (internalReset)
                return response.json().token;
            return this._talk.broadcast(`An email has been sent with a link to reset password. <i class="fa fa-smile-o" aria-hidden="true"></i>`);
        })
            .catch(err => {
            if (JSON.parse(err.status) == 404) {
                this._talk.broadcast(`No user found associated with provided email <i class="fa fa-frown-o" aria-hidden="true"></i>`);
            }
            else {
                this._talk.handle(err);
            }
        });
    }
    resetPassword(token, password, customMsg) {
        return this._http.post(this.userURL + "/resetpassword", { "token": token, "password": password })
            .toPromise()
            .then(response => {
            return this._talk.broadcast(`${customMsg || 'Your password has been reset'}. <i class="fa fa-smile-o" aria-hidden="true"></i>`);
        })
            .catch(err => {
            if (JSON.parse(err.status) == 404) {
                this._talk.broadcast(`Your token wasn't found or had expired <i class="fa fa-frown-o" aria-hidden="true"></i> Please request a new token and try again`);
            }
            else {
                this._talk.handle(err);
            }
        });
    }
    pullUserById(id) {
        return this._http.get(`${this.userURL}/${id}`)
            .toPromise()
            .then(response => response.json());
    }
};
exports.UsersService = UsersService;
exports.UsersService = UsersService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        router_1.ActivatedRoute,
        notification_service_1.NotificationService,
        router_1.Router])
], UsersService);
//# sourceMappingURL=users.service.js.map